<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4.453 22.666c.12.21.295.384.506.503l10.353 5.977a1.359 1.359 0 001.376 0l10.353-5.978a1.358 1.358 0 00.688-1.19V10.022a1.359 1.359 0 00-.688-1.192L16.687 2.853a1.357 1.357 0 00-1.375 0L4.96 8.831a1.358 1.358 0 00-.688 1.191v11.955c-.003.242.06.48.182.69zm8.232-2.116a1.332 1.332 0 01-2.663 0l.002-9.139a1.389 1.389 0 011.511-1.294 2.368 2.368 0 011.815.812l.403.481 5.562 6.657v-6.619a1.332 1.332 0 012.662 0l-.001 9.14a1.39 1.39 0 01-1.512 1.293 2.367 2.367 0 01-1.815-.811l-5.965-7.139v6.62z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandNginxFilled'
}
</script>
